import VueI18n from 'vue-i18n'
// import messages from './messages'
const messages = require('./messages-' + process.env.VUE_APP_NAME).default;
import locale from './locale'

export default () => {
    return new VueI18n({
        locale: locale.locale,
        messages,
    })
}